
import { Component, Emit, Prop, Vue } from "nuxt-property-decorator";

interface DeliveryOption {
  value: string;
  label: string;
  icon: string;
}

@Component
export default class DeliveryTypeRadio extends Vue {
  @Prop({ required: true }) readonly selectPelletsOption!: string;

  @Emit()
  updatePelletsValue(value: string): string {
    return value;
  }

  options: DeliveryOption[] = [
    { value: "loose", label: "Lose Ware", icon: "delivery" },
    { value: "pallet", label: "Sackware", icon: "package" },
    { value: "bigbag", label: "Big Bags", icon: "bag" },
  ];

  handleKeydown(event: KeyboardEvent, currentIndex: number) {
    if (event.key === "Enter" || event.key === " ") {
      if (event.key === " ") {
        event.preventDefault();
      }
      this.updatePelletsValue(this.options[currentIndex].value);
      return;
    }

    const forwardKeys = ["ArrowRight", "ArrowDown"];
    const backwardKeys = ["ArrowLeft", "ArrowUp"];
    const isForward = forwardKeys.includes(event.key);
    const isBackward = backwardKeys.includes(event.key);
    if (!isForward && !isBackward) {
      return;
    }

    event.preventDefault();
    const total = this.options.length;
    const delta = isForward ? 1 : -1;
    const nextIndex = (currentIndex + delta + total) % total;

    this.updatePelletsValue(this.options[nextIndex].value);
    this.$nextTick(() => {
      const inputs = this.$el.querySelectorAll<HTMLInputElement>(
        'input[type="radio"]',
      );
      inputs[nextIndex]?.focus();
    });
  }
}
